import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const IntegrationSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { provider } = useParams<{ provider: string }>();

  useEffect(() => {
    // Redirect with query params to trigger toast notification
    const timer = setTimeout(() => {
      navigate(`/integrations?connected=true&provider=${provider || "jira"}`, {
        replace: true,
      });
    }, 1500); // 1.5 second delay to show success briefly

    return () => clearTimeout(timer);
  }, [navigate, provider]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="mb-4">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-4">
            <svg
              className="w-8 h-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Integration Connected
        </h2>
        <p className="text-gray-600">Redirecting to integrations...</p>
      </div>
    </div>
  );
};
